
import axiosInstance from "./axiosInstance";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

interface LoginResponse {
  token?: string;
  message: string;
  statusCode: number;
}

export const loginUser = async (
  email: string,
  password: string
): Promise<LoginResponse> => {
  try {
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const deviceId = result.visitorId;

    const response = await axiosInstance.post("/login", {
      email,
      password,
      deviceId,
    });

    const resData = response.data?.data;

    return resData;

  } catch (error: any) {
    const status = error.response?.status;

    if (status === 403) {
      throw new Error("Your unique ID has changed. Please use the same device and Chrome profile you used earlier.");
    }

    if (status === 401 || status === 404) {
      throw new Error("Invalid email or password");
    }

    throw new Error("Something went wrong. Please try again.");
  }
};
